
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function RadioButton(props) {
    let elems;
    return reactElement("div", createObj(singleton((elems = [reactElement("input", {
        className: join(" ", ["cursor-pointer", "accent-primary"]),
        type: "radio",
        id: concat("radio-button-", ...props.Label),
        checked: props.Selected,
        onChange: (ev) => {
            props.OnSelect(ev.target.checked);
        },
        disabled: props.ComponentState === "disabled",
    }), reactElement("label", {
        className: join(" ", ["ml-2", "text-sm"]),
        children: props.Label,
        htmlFor: concat("radio-button-", ...props.Label),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

